var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import AppMessage from './appMessage';
var MailConfirmation = /** @class */ (function (_super) {
    __extends(MailConfirmation, _super);
    function MailConfirmation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailConfirmation.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'small-12 large-10 large-centered columns helper-margin-top-s' },
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'small-12 large-8 columns' },
                            React.createElement(AppMessage, { success: true, message: 'Ihre E-Mail-Adresse f\u00FCr die Kontowiederherstellung wurde best\u00E4tigt und gespeichert.' })))))));
    };
    return MailConfirmation;
}(Component));
export default MailConfirmation;
